import { createTheme } from "@mui/material"

const defaultTheme = createTheme()

export default defaultTheme